import { render, staticRenderFns } from "./AMSImg.vue?vue&type=template&id=6375f9f9&scoped=true&"
import script from "./AMSImg.vue?vue&type=script&lang=ts&"
export * from "./AMSImg.vue?vue&type=script&lang=ts&"
import style0 from "./AMSImg.vue?vue&type=style&index=0&id=6375f9f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375f9f9",
  null
  
)

export default component.exports